'use client';

import { useQuery } from '@tanstack/react-query';
import { api } from '../api/endpoints';

export const STANDARD_TITEL = 'Beschaffungsagent';

/**
 * Liefert den konfigurierbaren Anwendungstitel (config.prod.yaml: dashboard.titel).
 * Öffentlicher Endpoint (kein Token nötig) – nutzbar auch auf der Login-Seite.
 * Aendert sich praktisch nie zur Laufzeit, daher lange staleTime.
 */
export function useBranding() {
  return useQuery({
    queryKey: ['branding'],
    queryFn: api.getBranding,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
